/**
 * #13789 — item de GET /workflows. `tipo` decide em qual coluna do totem o id
 * é gravado: as faixas de id de workflow e workflowcustom se sobrepõem, então
 * a chave é sempre tipo + id (ver `workflowKey`).
 */
export type WorkflowTipo = 'base' | 'custom'

export interface WorkflowType {
  id: number
  nome: string
  tipo: WorkflowTipo
}

/** Chave única `tipo:id` usada pelo seletor e pela listagem. */
export function workflowKey(tipo: WorkflowTipo, id: number | string): string {
  return `${tipo}:${id}`
}

/** Inverso de `workflowKey`; `null` para vazio ou chave malformada. */
export function parseWorkflowKey(key: string | null | undefined): { tipo: WorkflowTipo; id: number } | null {
  if (!key) return null
  const [tipo, rawId] = key.split(':')
  const id = parseInt(rawId, 10)
  if ((tipo !== 'base' && tipo !== 'custom') || !Number.isInteger(id) || id <= 0) return null
  return { tipo, id }
}
